export class OpDataUtil {
    static valueEquals(firstPrimitive, secondPrimitive) {
        if (firstPrimitive == null && secondPrimitive == null)
            return true

        if (firstPrimitive == null && secondPrimitive != null)
            return false

        if (firstPrimitive != null && secondPrimitive == null)
            return false

        return firstPrimitive == secondPrimitive
    }
}